import {
  GET_SUMMARIES_REQUEST,
  GET_SUMMARIES_SUCCESS,
  GET_SUMMARIES_FAILURE,
  RESET_SUMMARIES
} from '../../constants/summaries'

const initialState = {
  error: null
}

const summariesReducer = (state = initialState, action) => {
  const { type, keyNameLoading, keyNameData, payload, dummy } = action

  switch (type) {
    case GET_SUMMARIES_REQUEST:
      return {
        ...state,
        [keyNameLoading]: true,
        error: null // Reset error on new request
      }

    case GET_SUMMARIES_SUCCESS:
      return {
        ...state,
        [keyNameLoading]: false,
        [keyNameData]: payload,
        error: null // Clear any previous errors
      }

    case GET_SUMMARIES_FAILURE:
      return {
        ...state,
        [keyNameLoading]: false,
        error: payload,
        [keyNameData]: dummy
      }
    case RESET_SUMMARIES:
      return initialState

    default:
      return state
  }
}

export default summariesReducer
